import goodQuery from './goodQuery.vue'
export default goodQuery
